export const ENABLED_WIDGET_KEYS = [
  "siteNetwork",
  "eventLog",
  "alertLog",
  "eventTrends",
  "systemLog",
  "peopleFlow",
  "trafficStats",
  "nvrInfo"
];

// Controls widget menu options
export const defaultWidgetSet = {
  siteNetwork: { id: "site-network", check: true },
  eventLog: { id: "event-log", check: true },
  alertLog: { id: "alert-log", check: true },
  eventTrends: { id: "event-trends", check: true },
  systemLog: { id: "system-log", check: true },
  peopleFlow: { id: "people-flow", check: true },
  trafficStats: { id: "traffic-stats", check: true },
  nvrInfo: { id: "nvr-info", check: true },
};

export const defaultTimeRanges = {
  "1d": { label: "Last 24 Hours", value: "1d" },
  "1w": { label: "Last 7 days", value: "1w" },
}

export const defaultTimeRangeOptions = [
  defaultTimeRanges["1d"],
  defaultTimeRanges["1w"],
];

// Controls initial grid layout placement and size
export const defaultWidgetCard = [
  {
    i: "site-network",
    w: 6, h: 15, x: 0, y: 0, visible: true,
  },
  {
    i: "event-log",
    w: 2, h: 15, x: 0, y: 15, visible: true,
  },
  {
    i: "alert-log",
    w: 4, h: 15, x: 2, y: 15, visible: true,
  },
  {
    i: "event-trends",
    w: 2, h: 15, x: 0, y: 30, visible: true,
  },
  {
    i: "system-log",
    w: 4, h: 15, x: 2, y: 30, visible: true,
  },
  {
    i: "people-flow",
    w: 6, h: 15, x: 0, y: 45, visible: true,
  },
  {
    i: "traffic-stats",
    w: 6, h: 15, x: 0, y: 60, visible: true,
  },
  {
    i: "nvr-info",
    w: 6, h: 15, x: 0, y: 75, visible: true,
  },
];

export const defaultActionStatus = {
  draggable: false,
  update: {
    system: false,
    custom: false,
  },
  reset: {
    system: false,
    custom: false,
  },
};

export const widgetKeyMap = {
  siteNetwork: "site-network",
  eventLog: "event-log",
  alertLog: "alert-log",
  eventTrends: "event-trends",
  systemLog: "system-log",
  peopleFlow: "people-flow",
  trafficStats: "traffic-stats",
  nvrInfo: "nvr-info",
};

export const TWO_POINT_FOUR_GHZ_RANGE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
export const FIVE_GHZ_RANGE = [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165];
export const SIX_GHZ_RANGE = [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 97, 101, 105, 109, 113, 117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 233];

export const mockHours = ["06:00", "08:00", "10:00", "12:00", "14:00", "16:00", "18:00", "20:00", "22:00", "24:00"];
export const mockEventTrendsDates = ["4/30", "5/1", "5/2", "5/3", "5/4", "5/5", "5/6"];

export const mockAlerts = [
  { type: "Camera Offline", level: "Critical", content: "Camera 'Store A - Front Door' disconnected", time: "2026/09/05 14:01:22" },
  { type: "NVR Storage Full", level: "Major", content: "NVR 'Warehouse-NVR-03' storage is 99% full", time: "2026/09/05 13:30:00" },
  { type: "Motion Alarm", level: "Warning", content: "Motion detected on 'Office - Reception'", time: "2026/09/05 13:12:15" },
  { type: "Network Latency", level: "Info", content: "High latency detected on Switch Port 3", time: "2026/09/05 12:45:00" },
];

export const mockLogs = [
  { time: "2026/09/05 14:22:01", operator: "admin@company.com", category: "Device Control", alertType: "Reboot Camera", result: "Success" },
  { time: "2026/09/05 13:45:10", operator: "manager@company.com", category: "View Live", alertType: "Export Video", result: "Success" },
  { time: "2026/09/05 13:15:30", operator: "admin@company.com", category: "Settings", alertType: "Modify Alarm Rule", result: "Failed" },
  { time: "2026/09/05 12:30:15", operator: "operator@company.com", category: "User Login", alertType: "Login Portal", result: "Success" },
];

export const mockNvrData = [
  { name: "HQ-NVR-01", ip: "192.168.10.20", camsOnline: 28, camsOffline: 2, usedCap: "18.4 TB", totalCap: "24 TB" },
  { name: "Retail-NVR-02", ip: "192.168.20.15", camsOnline: 16, camsOffline: 0, usedCap: "8.5 TB", totalCap: "12 TB" },
  { name: "Warehouse-NVR-03", ip: "10.8.20.9", camsOnline: 42, camsOffline: 5, usedCap: "31.2 TB", totalCap: "40 TB" },
  { name: "Campus-NVR-04", ip: "172.16.5.35", camsOnline: 12, camsOffline: 1, usedCap: "4.8 TB", totalCap: "8 TB" },
  { name: "Factory-NVR-05", ip: "10.10.108.50", camsOnline: 64, camsOffline: 0, usedCap: "52.7 TB", totalCap: "64 TB" },
];

export const peopleFlowDataset = {
  all: [
    { name: "Cam-1", type: "bar", color: "#1976D2", data: [5, 8, 12, 18, 14, 22, 19, 11, 6, 2] },
    { name: "Cam-2", type: "bar", color: "#4CAF50", data: [3, 6, 9, 15, 12, 18, 15, 8, 4, 1] },
    { name: "Cam-3", type: "bar", color: "#FFA726", data: [4, 5, 8, 12, 10, 15, 12, 6, 3, 0] },
  ],
  cam1: [
    { name: "Cam-1", type: "bar", color: "#1976D2", data: [5, 8, 12, 18, 14, 22, 19, 11, 6, 2] },
  ],
  cam2: [
    { name: "Cam-2", type: "bar", color: "#4CAF50", data: [3, 6, 9, 15, 12, 18, 15, 8, 4, 1] },
  ],
  cam3: [
    { name: "Cam-3", type: "bar", color: "#FFA726", data: [4, 5, 8, 12, 10, 15, 12, 6, 3, 0] },
  ],
};

export const trafficDataset = {
  cam1: {
    passing: [12, 18, 25, 30, 28, 35, 32, 22, 14, 8],
    entering: [8, 12, 18, 20, 19, 25, 22, 14, 8, 4],
    leaving: [7, 10, 16, 18, 20, 22, 24, 16, 9, 5],
    entryRate: [66, 66, 72, 66, 67, 71, 68, 63, 57, 50],
  },
  cam2: {
    passing: [15, 22, 32, 45, 38, 52, 48, 30, 18, 10],
    entering: [10, 15, 24, 30, 27, 38, 34, 20, 11, 5],
    leaving: [8, 12, 20, 26, 29, 35, 38, 22, 13, 7],
    entryRate: [66, 68, 75, 66, 71, 73, 70, 66, 61, 50],
  },
  cam3: {
    passing: [10, 15, 20, 28, 24, 30, 27, 18, 12, 6],
    entering: [6, 10, 14, 18, 16, 20, 18, 12, 7, 3],
    leaving: [5, 8, 12, 15, 17, 19, 20, 13, 8, 4],
    entryRate: [60, 66, 70, 64, 66, 66, 66, 66, 58, 50],
  },
};

export const mockEvents = [
  { type: "Motion detected", camera: "Store A - Front Door", time: "2026/09/05 14:32:10" },
  { type: "Intrusion warning", camera: "Warehouse - Back Gate", time: "2026/09/05 14:15:02" },
  { type: "Face recognized", camera: "Office - Reception", time: "2026/09/05 13:58:44" },
  { type: "Line crossing", camera: "Fence - North Area", time: "2026/09/05 13:42:19" },
];

export const mockEventTrendsDataset = {
  all: [120, 180, 240, 210, 280, 230, 310],
  "HQ-NVR-01": [30, 45, 60, 50, 70, 55, 75],
  "Retail-NVR-02": [20, 30, 40, 35, 45, 40, 50],
  "Warehouse-NVR-03": [40, 60, 80, 70, 90, 75, 100],
  "Campus-NVR-04": [10, 15, 20, 18, 25, 20, 30],
  "Factory-NVR-05": [20, 30, 40, 37, 50, 40, 55],
};